export const PLANS = ['free', 'bronze', 'silver', 'gold'];

const PLAN_RANK = {
  free: 0,
  bronze: 1,
  silver: 2,
  gold: 3,
};

// Maps feature keys to the minimum plan required to access them.
// Add entries here as features are defined, e.g.: reports: 'bronze'
export const FEATURES = {};

export const planRank = (plan) => PLAN_RANK[plan] ?? 0;

export const meetsMinimumPlan = (activePlan, requiredPlan) =>
  planRank(activePlan) >= planRank(requiredPlan);

export const isSubscriptionActive = (subscription) =>
  subscription?.status === 'active' || subscription?.status === 'trial';
